module.exports = require('./helpers/bundle-url').getBundleURL('c9mUi') + "logo-dark.ba5147f0.svg";